
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/programme-ambassadeur-ecoflow",
      function () {
        return require("private-next-pages/programme-ambassadeur-ecoflow/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/programme-ambassadeur-ecoflow"])
      });
    }
  